// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/myg.scss
// module id = 716
// module chunks = 0